import Vue from 'vue';
import Vuex from 'vuex';

import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import patient from './modules/patient';
import interview from './modules/interview';
import questions from './modules/questions';
import notes from './modules/note';
import measurement from "./modules/measurement";
import menus from "./modules/menu";
import survey from './modules/survey';
import productCategory from './modules/productCategory';
import sharing from './modules/sharing';
import print from './modules/print';
import clipboard from './modules/clipboard';
import calendarEvent from "./modules/calendarEvent";
import discountCode from './modules/discountCode';
import education from "./modules/education";
import mobileAppAccess from "./modules/mobileAppAccess";

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    patient,
    interview,
    questions,
    notes,
    measurement,
    menus,
    survey,
    productCategory,
    sharing,
    print,
    clipboard,
    calendarEvent,
    discountCode,
    education,
    mobileAppAccess,
  },
    state: {
      modals: [],
      modal: {
        visible: false,
        component: null,
        data: null,
        options: null,
      },
      configuration: {
        title: '',
        diets: [],
        equipments: [],
        meals: [],
        mode: '',
        readonly: true,
        search: {
          advanced: '',
          food: '',
          product: ''
        },
        shoppingList: '',
        store: '',
        tags: [],
        schemaTags: [],
        system: false,
        nutrients_percentage: {},
        edit_session_id: null,
        sharedResources: {
          products: [],
        },
        sentToMobileApp: false,
      },
      countries: [],
      menu: {
        schema: {
          days: []
        },
        patient: null,
        days: null,
      },
      dictionaries: {
        tags: [],
        diets: [],
        equipments: [],
        meals: [],
        schemas: [],
        subscriptions: [],
        nutrients: [],
        product_categories: [],
        products: [],
      },
      user: {
        id: null,
        name: null,
        email: '',
        permissions: [],
        is_active: false,
        can_use_sharing: false,
        max_menu_days_length: 7,
        role: null,
      },
      settings: {
        invoice: {},
        print_settings: {},
        profile: {},
        appearance: {},
        nutrients_print: [],
        email_settings: {
          content: '',
          title: '',
        },
      },
      commentsHidden: true,
      productReplacements: [],
      foodsWithReplacements: [],
      productsReplaced: false,
      foodsWithSearchedProduct: [],
      productsSameAsSearchedProduct: [],
      dragAndCopyEnabled: false,
      sentToMobileAppAt: null,
    },
    getters,
    mutations,
    actions,
  }
);
